import { Component } from "preact";
import classNames from "classnames";

import styles from "./Navigation.scss";
import AnchorLink from "../AnchorLink/AnchorLink";

export default class Navigation extends Component {

	render(props, state, ctx) {
		const {navOpen = false} = state;

		return (
			<nav className={styles.Navigation}>
				<div className={styles.Container}>
					<AnchorLink target="root">
						<img className={classNames(styles.CenterVertical, styles.Logo)} src="/assets/tooth.svg"
							 width="18" height="18" alt=""/>
						<span className={classNames(styles.CenterVertical, styles.Brand)}>
							Stonegate Dental Practice
						</span>
					</AnchorLink>

					<ul className={classNames(styles.Links, {[styles.NavOpen]: navOpen})}>
						<li><AnchorLink target={"about"}>ABOUT</AnchorLink></li>
						<li><AnchorLink target={"find"}>FIND US</AnchorLink></li>
						<li><AnchorLink target={"contact"}>CONTACT</AnchorLink></li>
					</ul>
					<div className={classNames(styles.CenterVertical, styles.OpenNavButton)} onClick={() => this.setState({navOpen: !navOpen})}>
						<div style={{ position: "relative", width: "100%", height: "100%" }}>
							<i style={{ fontSize: 25, color: "#FFF" }}
							   className={classNames("material-icons", styles.CenterXY)}>menu</i>
						</div>
					</div>
				</div>
			</nav>
		);
	};
}


// WEBPACK FOOTER //
// ./components/Navigation/Navigation.js